import { createBrowserRouter } from 'react-router-dom';

import { customRoutes } from '@/modules/CustomRouter/routes';

const CustomRouter = createBrowserRouter(customRoutes);
window.CustomRouter = CustomRouter; // for debugging

export default CustomRouter;
